export const SELECT_MOB = 'SELECT_MOB';